<!--
 * @FileDescription: tablist
 * @Autor: liuwp
 * @Date: 2022-08-09 15:50:08
 * @LastEditors: liuwp
 * @LastEditTime: 2022-09-13 18:07:27
-->
<template>
  <section ref="tableList" class="yxtbiz-select-rank-table-list">
    <yxt-table
      ref="table"
      :data="tableData"
      style="width: 100%;"
      :row-key="(row) => { return row.sourceId }"
      @select="selectRow"
      @select-all="selectAll"
      height="100%">
      <yxt-table-column
        type="selection"
        :reserve-selection="true"
        width="45">
      </yxt-table-column>
      <!-- 榜单名称 -->
      <yxt-table-column
        prop="title"
        :label="$t('pc_biz_select_rank_title')"
        width="250">
      </yxt-table-column>
      <!-- 榜单内容 -->
      <yxt-table-column
        :label="$t('pc_biz_select_rank_content')"
        width="300">
        <template slot-scope="scope">
          {{ showName(scope.row) }}
        </template>
      </yxt-table-column>
    </yxt-table>
  </section>
</template>
<script>
export default {
  props: {
    selectedValue: {
      type: Array,
      default: []
    },
    maxLength: {
      type: Number
    },
    tableData: {
      type: Array,
      default: []
    }
  },
  watch: {
    selectedValue: {
      handler() {
        this.checkSelected();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    showName(row) {
      // 部门的 排行榜
      return `${row.scopes.find(item => item === 'deptScope') ? this.$t('pc_biz_select_rank_departmental') : ''}${row.objectName}${row.attributeName}${ this.$t('pc_biz_select_rank') }`;
    },
    checkSelected() {
      this.$nextTick(() => {
        if (this.selectedValue.length === 0) {
          this.$refs.table.clearSelection();
          return;
        }
        this.tableData.forEach(row => {
          if (this.selectedValue.find(item => item.sourceId === row.sourceId)) {
            this.$refs.table.toggleRowSelection(row, true);
          } else {
            this.$refs.table.toggleRowSelection(row, false);
          }
        });
      });
    },
    selectAll(selection) {
      let arr = JSON.parse(JSON.stringify(selection)) || [];
      if (arr.length > this.maxLength) {
        this.$message({
          message: this.$t('pc_biz_select_rank_tips'), // '选择的榜单已达上限'
          type: 'warning'
        });
        this.tableData.forEach(item => {
          if (!this.selectedValue.find(item1 => item1.sourceId === item.sourceId)) {
            this.$refs.table.toggleRowSelection(item, false);
          }
        });
        return;
      }
      this.$emit('selectValue', arr);
    },
    selectRow(selection, row) {
      let hasRow = this.selectedValue.find(item => item.sourceId === row.sourceId);
      if (!hasRow) {
        if (this.selectedValue.length === this.maxLength) {
          this.$refs.table.toggleRowSelection(row, false);
          this.$message({
            message: this.$t('pc_biz_select_rank_tips'), // '选择的榜单已达上限'
            type: 'warning'
          });
          return;
        }
        this.selectedValue.push(row);
        return;
      }
      this.$emit('selectedValue', this.selectedValue.splice(this.selectedValue.findIndex(item => item.sourceId === row.sourceId), 1));
    }
  }
};
</script>
<style lang="scss" scoped>
.yxtbiz-select-rank-table-list {
  width: 100%;
  flex: 1;
  overflow: hidden;
  // margin-bottom: 16px;
}
</style>
